/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  logo,
  baricon,
  baricon1,
  searchnormal,
  noteicon,
  user06,
  settingicon01,
  noteicon1,
} from "./imagepath";
import config from "../config";
import { toast, ToastContainer } from "react-toastify";
import { FaBuilding, FaCheckCircle, FaTimesCircle, FaExclamationCircle } from "react-icons/fa";

const BusinessHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("User");
  const [profileCompletion, setProfileCompletion] = useState(0);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState(localStorage.getItem("profileImage") || user06);
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const userUUID = localStorage.getItem("userUUID");

  useEffect(() => {
    const fetchProfileCompletion = async () => {
      try {
        const response = await fetch(`${config.API_URL}get_userdata.php?user_id=${userUUID}`);
        const data = await response.json();
        if (data.success === "1") {
          setProfileCompletion(data.user.profile_completion || 0);
          setUserName(`${data.user.first_name} ${data.user.last_name}`.trim() || "User");
        }
      } catch (error) {
        console.error("Error fetching profile completion:", error);
      }
    };

    const fetchBusinessData = async () => {
      try {
        const businessId = localStorage.getItem("BusinessID");
        if (!businessId) return;

        const response = await fetch(`${config.API_URL}get_businessdata.php?business_id=${businessId}`);
        const data = await response.json();

        if (data.success === "1") {
          const newImageUrl = data.business.profile_image 
            ? `${config.API_URL}uploads/profile_images/business_images/${data.business.profile_image}`
            : user06;
          setProfileImageUrl(newImageUrl);
          localStorage.setItem("profileImage", newImageUrl);
        }
      } catch (error) {
        console.error("Error fetching business data:", error);
      }
    };

    const fetchInstitutions = async () => {
      try {
        if (!userUUID) return;

        const response = await fetch(`${config.API_URL}get_my_institutions.php?user_id=${userUUID}`);
        const data = await response.json();

        if (data.status === "success" && data.institutions.length > 0) {
          const institutionData = data.institutions.map((institution) => ({
            business_id: institution.business_id,
            institution_name: institution.institution_name,
            is_active: institution.is_active,
          }));

          setInstitutions(institutionData);

          // Load stored business ID from localStorage
          const storedBusinessID = localStorage.getItem("BusinessID");
          const activeInstitution = institutionData.find((inst) => inst.business_id === storedBusinessID) || institutionData[0];

          // Save selected business ID in localStorage
          localStorage.setItem("BusinessID", activeInstitution.business_id);
          setSelectedInstitution(activeInstitution);
        } else {
          setSelectedInstitution({
            institution_name: "No Business",
            business_id: "N/A",
          });
        }
      } catch (error) {
        console.error("Error fetching institutions:", error);
        setSelectedInstitution({
          institution_name: "No Business",
          business_id: "N/A",
        });
      }
    };

    if (userUUID) {
      fetchProfileCompletion();
      fetchInstitutions();
      fetchBusinessData();
    }

    const interval = setInterval(fetchProfileCompletion, 2000);
    return () => clearInterval(interval);
  }, [userUUID]);

  const handleInstitutionSwitch = async (institution) => {
    try {
      if (!userUUID || !institution.business_id) return;

      const response = await fetch(`${config.API_URL}update_business_status.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userUUID, business_id: institution.business_id }),
      });

      const result = await response.json();

      if (response.ok && result.status === "success") {
        localStorage.setItem("BusinessID", institution.business_id);
        setSelectedInstitution(institution);
        navigate(`/business/${institution.institution_name}`);

        // Refresh business data
        const newResponse = await fetch(`${config.API_URL}get_businessdata.php?business_id=${institution.business_id}`);
        const newData = await newResponse.json();

        if (newData.success === "1") {
          const newImgUrl = newData.business.profile_image 
            ? `${config.API_URL}uploads/profile_images/business_images/${newData.business.profile_image}`
            : user06;
          setProfileImageUrl(newImgUrl);
          localStorage.setItem("profileImage", newImgUrl);
        }
      } else {
        toast.error(result.message || "Failed to switch business");
      }
    } catch (error) {
      console.error("Error activating business:", error);
      toast.error("Error switching business");
    }
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
    document.getElementsByTagName("html")[0].classList.toggle("menu-opened");
    document.getElementsByClassName("sidebar-overlay")[0].classList.toggle("opened");
  };

  const openDrawer = () => {
    const div = document.querySelector(".main-wrapper");
    if (div?.className?.includes("open-msg-box")) {
      div?.classList?.remove("open-msg-box");
    } else {
      div?.classList?.add("open-msg-box");
    }
  };

  const handleDashboardClick = () => {
    navigate("/patient-dashboard");
  };

  const handleLogout = () => {
    localStorage.removeItem("userUUID");
    localStorage.removeItem("BusinessID");
    localStorage.removeItem("profileImage");
    navigate("/login");
  };

  const filteredInstitutions = institutions.filter(
    (institution) => institution.business_id !== selectedInstitution?.business_id
  );

  return (
    <div className="main-wrapper">
      <ToastContainer position="top-center" />
      <div className="header">
        <div className="header-left">
          <Link to="/admin-dashboard" className="logo">
            <img src={logo} height={40} alt="" />
          </Link>
        </div>
        <Link id="toggle_btn" to="#" onClick={handlesidebar}>
          <img src={baricon} alt="" />
        </Link>
        <Link id="mobile_btn" className="mobile_btn float-start" to="#" onClick={handlesidebarmobilemenu}>
          <img src={baricon1} alt="" />
        </Link>
        
        <div className="top-nav-search mob-view">
          <form>
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
            />
            <Link className="btn">
              <img src={searchnormal} alt="" />
            </Link>
          </form>
        </div>
        
        <ul className="nav user-menu d-flex align-items-center float-end">
          <li className="nav-item d-none d-sm-block mx-2">
            <button className="btn btn-primary" onClick={handleDashboardClick}>
              Personal Dashboard
            </button>
          </li>
          
          {/* <li className="nav-item dropdown d-none d-sm-block mx-2">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <img src={noteicon} alt="" />
              <span className="pulse" />
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span>Notifications</span>
              </div>
              <div className="drop-scroll">
                <ul className="notification-list">
                  <li className="notification-message">
                    <Link to="/user-activity">
                      <div className="media">
                        <span className="avatar">V</span>
                        <div className="media-body">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/user-activity">View all Notifications</Link>
              </div>
            </div>
          </li> */}
          
          {/* <li className="nav-item dropdown d-none d-sm-block mx-2">
            <Link
              onClick={openDrawer}
              id="open_msg_box"
              className="hasnotifications nav-link"
            >
              <img src={noteicon1} alt="" />
              <span className="pulse" />
            </Link>
          </li> */}
          
          <li className="nav-item dropdown has-arrow user-profile-list mx-2">
            <Link
              to="#"
              className="dropdown-toggle nav-link user-link"
              data-bs-toggle="dropdown"
            >
              <div className="user-names">
                <h5>{selectedInstitution?.institution_name || "No Business"}</h5>
                <span>ID: {selectedInstitution?.business_id || "N/A"}</span>
                {profileCompletion < 100 && (
                  <small className="text-warning">Profile {profileCompletion}% complete</small>
                )}
              </div>
              <span className="user-img">
                <img src={profileImageUrl} alt="User" style={{ width: "40px", height: "40px", objectFit: "cover" }} />
              </span>
            </Link>
            <div className="dropdown-menu">
              <Link className="dropdown-item" to="/profile-business">
                My Profile
              </Link>
              <Link className="dropdown-item" to="/edit-profile-business">
                Edit Profile
              </Link>
              
              {institutions.length > 0 && (
                <>
                  <div className="dropdown-divider"></div>
                  <div className="dropdown-header">Switch Business</div>
                  {filteredInstitutions.map((institution) => (
                    <button
                      key={institution.business_id}
                      className="dropdown-item business-item"
                      onClick={() => handleInstitutionSwitch(institution)}
                    >
                      <FaBuilding className="me-2" />
                      {institution.institution_name}
                    </button>
                  ))}
                </>
              )}
              
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to="/register-business">
                <FaBuilding className="me-2" />
                Add New Business
              </Link>
              
              <div className="dropdown-divider"></div>
              <button 
                className="dropdown-item text-danger" 
                onClick={() => setShowLogoutModal(true)}
              >
                Logout
              </button>
            </div>
          </li>
        </ul>
        
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu float-end">
          <Link
            to="#"
            className="dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-ellipsis-vertical" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <div className="user-card sm p-3">
              <div className="d-flex align-items-center">
                <div className="user-avatar me-3">
                  <img
                    src={profileImageUrl}
                    alt="Profile"
                    style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                  />
                </div>
                <div className="user-info">
                  <h6>{selectedInstitution?.institution_name || "No Business"}</h6>
                  <small className="text-muted">ID: {selectedInstitution?.business_id || "N/A"}</small>
                </div>
              </div>
            </div>
            
            <div className="dropdown-divider"></div>
            
            <Link className="dropdown-item" to="/profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="/edit-profile">
              Edit Profile
            </Link>
            
            {institutions.length > 0 && (
              <>
                <div className="dropdown-divider"></div>
                <div className="dropdown-header">Switch Business</div>
                {filteredInstitutions.map((institution) => (
                  <button
                    key={institution.business_id}
                    className="dropdown-item business-item"
                    onClick={() => handleInstitutionSwitch(institution)}
                  >
                    <FaBuilding className="me-2" />
                    {institution.institution_name}
                  </button>
                ))}
              </>
            )}
            
            <div className="dropdown-divider"></div>
            <Link className="dropdown-item" to="/register-business">
              <FaBuilding className="me-2" />
              Add New Business
            </Link>
            
            <div className="dropdown-divider"></div>
            <button 
              className="dropdown-item text-danger" 
              onClick={() => setShowLogoutModal(true)}
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="modal-overlay" style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1050
        }}>
          <div className="modal-content" style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            maxWidth: "400px",
            width: "100%"
          }}>
            <div className="modal-body text-center">
              <p className="mb-4">
                <FaExclamationCircle style={{ color: "#ffc107", fontSize: "24px", marginRight: "8px" }} />
                Do you really want to logout?
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button 
                  className="btn btn-success"
                  onClick={() => {
                    setShowLogoutModal(false);
                    handleLogout();
                  }}
                >
                  <FaCheckCircle className="me-2" />
                  Yes, Logout
                </button>
                <button 
                  className="btn btn-danger"
                  onClick={() => setShowLogoutModal(false)}
                >
                  <FaTimesCircle className="me-2" />
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessHeader;